import { useState } from "react";
import { Plus, Search, Filter } from "lucide-react";

export default function ContractToolbar({
  onAdd,
  onSearch,
  onFilterChange,
}) {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("all");

  function handleSearch(value) {
    setSearch(value);
    onSearch?.(value);
  }

  function handleStatus(value) {
    setStatus(value);
    onFilterChange?.({ status: value });
  }

  return (
    <div className="bg-white shadow-sm rounded-2xl p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">

      {/* LEFT: Title */}
      <div>
        <h1 className="text-xl font-semibold text-gray-800">
          Contract Management
        </h1>
        <p className="text-sm text-gray-500">
          Manage contracts, templates & assignments
        </p>
      </div>

      {/* RIGHT: Actions */}
      <div className="flex flex-col md:flex-row gap-3 md:items-center">

        {/* SEARCH */}
        <div className="flex items-center bg-gray-50 border rounded-lg px-3 py-2 w-full md:w-72">
          <Search size={16} className="text-gray-400" />
          <input
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search contracts..."
            className="bg-transparent outline-none ml-2 w-full text-sm"
          />
        </div>

        {/* ADD BUTTON */}
        <button
          onClick={onAdd}
          className="
            flex items-center gap-2
            bg-[#375AE7] hover:bg-[#375AE7]
            text-white px-4 py-2 rounded-lg
            shadow-sm transition
          "
        >
          <Plus size={16} />
          New Contract
        </button>
      </div>
    </div>
  );
}